<template>

    <div class="zp-main">
        <el-image v-show="zpPost.workouttype == '校园招聘'" style="margin: auto;height: 170px;width: 1515px;border-radius: 4px;"
                  :src="banner"/>
        <div :class="{'zp-height': isHeight}" class="zp-content">

            <el-row >
                <el-col style="margin: 15px;">
                    <el-breadcrumb separator-class="el-icon-arrow-right">
                        <el-breadcrumb-item :to="{ path: '/recruit/list' }"><i class="el-icon-menu"></i> {{zpPost.workouttype}}
                        </el-breadcrumb-item>
                        <el-breadcrumb-item>职位列表</el-breadcrumb-item>
                    </el-breadcrumb>
                </el-col>
            </el-row>
            <el-row class="mb8">
                <el-col :span="4">
                    <el-input
                            type="text"
                            prefix-icon="el-icon-search"
                            v-model="zpPost.postname"
                            placeholder="请输入岗位名称"
                            style="width: 270px; cursor: pointer"
                            @keyup.enter.native="getList"
                    ></el-input>
                </el-col>
                <el-col :span="2">
                    <el-button type="primary" size="medium" @click="getList">搜索</el-button>
                </el-col>
            </el-row>

            <el-table
                    ref="filterTable"
                    :data="tableData"
                    max-height="450px"
                    stripe
                    highlight-current-row
                    style="width: 100%">

                <el-table-column
                        prop="postname"
                        label="岗位名称">
                </el-table-column>
                <el-table-column
                        prop="demandcount"
                        label="招聘人数">
                </el-table-column>
                <el-table-column
                        prop="workaddr"
                        label="工作地点">
                </el-table-column>
                <el-table-column
                        :formatter="tableFormat"
                        prop="zpstate"
                        label="状态">
                </el-table-column>
                <el-table-column
                        prop="fbzwdate"
                        label="发布时间">
                </el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-button
                                type="primary"
                                size="mini"
                                @click="handleEdit(scope.$index, scope.row)">查看详细
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>

            <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :page-sizes="[10, 15, 20]"
                    :page-size="page.size"
                    background
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="page.total">
            </el-pagination>
        </div>
    </div>
</template>

<script>

    export default {
        name: "zp_list",
        data() {
            return {
                url: '/zp-post/findPage',
                tableData: [],
                page: {
                    size: 10,
                    total: 100,
                    current: 1
                },
                zpPost: {
                    postname: '',
                    workouttype: '校园招聘'
                },
                dicItem:[],
                isHeight: false,
                banner: require('@/assets/banner.jpg')
            }
        },
        created() {
            this.getDic();
            this.zpPost.workouttype = this.$route.query.workouttype;
            if(this.zpPost.workouttype == '社会招聘'){
                this.isHeight = true;
            }
        },
        mounted() {
            this.getList();
        },
        watch: {
            $route(to, from) {
                if (this.$route.query.workouttype) {
                    console.info( "重新调用接口获取页面数据" )
                    this.zpPost.workouttype = this.$route.query.workouttype;
                    if(this.zpPost.workouttype == '社会招聘'){
                        this.isHeight = true;
                    }else {
                        this.isHeight = false
                    }
                    this.getList();
                }
            }
        },
        methods: {
            getList() {
                console.log(this.zpPost.postname)
                let query = Object.assign({}, this.zpPost, this.page);
                this.$HttpService.get(this.url, query).then(res => {
                    console.log(res);
                    this.tableData = res.records;
                    this.page.total = res.total;
                }).catch(() => {

                })
            },
            getDic() {
                let query = Object.assign({}, this.zpPost, this.page);
                this.$HttpService.get('/common/getItem/zpstate').then(res => {
                    console.log(res);
                    this.dicItem = res;
                }).catch(() => {

                })
            },
            //表格内容格式转换
            tableFormat(row, column, cellValue, index){
                // 该函数一共有4个入参，分别是行、列、当前字段值、行下标
                // console.log(row, column, cellValue, index)
                //快速查找
                debugger;
                var newArr = this.dicItem.filter(function(p){
                    return p.value === row.zpstate;
                });
                return newArr[0].label;
            },
            handleCurrentChange(current) {
                this.page.current = current;
                this.getList();
            },
            handleSizeChange(size) {
                this.page.size = size;
                this.getList();
            },
            handleEdit(index, row) {
                console.log(row);
                this.$router.push({path: '/recruit/detail', query: {id: row.id}});
            }
        }
    }
</script>
<style scoped>

    .zp-main {
        height: 100%;
        width: 100%;
        position: relative;
    }

    .mb8 {
        margin-bottom: 8px;
    }

    .zp-content {
        margin: auto;
        height: 580px;
        width: 1500px;
        padding: 8px;
        background-color: #FFF;
        border-radius: 4px;
    }
    .zp-height {
        height: 780px;
    }

</style>
